import { containerBreakpoints } from "@/components/breakpoints"
import { Box, Text, Heading, Container } from "@chakra-ui/react"

const BlogHeader = (props: any) => {

    const { data } = props

    const before = {
        position: 'absolute',
        top: 0,
        content: '""',
        width: '7px',
        height: '7px',
        display: 'block',
        backgroundColor: '#cc0007',
        borderRadius: '50%',
        marginBottom: '16px'
    }
    const beforeCenter = { ...before, ...{ left: '50%' } }
    const beforeLeft = { ...before, ...{ left: 0 } }
    const beforeRight = { ...before, ...{ right: 0 } }

    const getSubtitleDecoration = () => {
        if (data.Alinhamento === 'Direita') {
            return beforeRight
        }
        if (data.Alinhamento === 'Centro') {
            return beforeCenter
        }
        return beforeLeft
    }

    const getTextAlign = () => {
        if (data.Alinhamento === 'Direta') {
            return 'end'
        }
        if (data.Alinhamento === 'Centro') {
            return 'center'
        }
        return 'start'
    }

    return <>
        <Box minH={220} maxH={460} pos={'relative'}>
            <Box
                w={'full'}
                bgSize={'cover'}
                bgImage={{
                    base: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
                    sm: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
                    md: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
                    lg: '/images/bg_slide.jpg',
                    xl: '/images/bg_slide.jpg',
                    '2xl': '/images/bg_slide.jpg',
                  }}
                // filter={'blur(4px)'}
                h={{
                    base: 200,
                    sm: 200,
                    md: 440,
                    lg: 440,
                    xl: 440,
                    '2xl': 440,
                }}
                p={10}
                className="div-header">

            </Box>
{/*             
            <Container maxW={containerBreakpoints} pt={'170px'} zIndex={2} pos={'relative'}>
                {data?.Subtitulo &&
                    <Text className={`${data?.ClasseCss}-subtitulo`} as='h5' _before={getSubtitleDecoration()} pos='relative' pt={'16px'} textAlign={getTextAlign()} w={'100%'} fontSize={'14px'} lineHeight={1.2} textTransform={'uppercase'} letterSpacing={'1.4px'} fontWeight={'500'} margin={'0 0 7px'} fontFamily={"'Plus Jakarta Sans', sans-serif"}>
                        {data?.Subtitulo}
                    </Text>
                }
                {data?.Titulo &&
                    <Heading className={`${data?.ClasseCss}-titulo`} mb={10} fontSize={'50px'} letterSpacing={'-2px'} textAlign={getTextAlign()} fontWeight={800} fontFamily={"'Plus Jakarta Sans', sans-serif"}>
                        {data?.Titulo}
                    </Heading>
                }
            </Container> */}
        </Box>
    </>
}

export default BlogHeader